import { apiFetch } from './api';

export type Sexo = 'Masculino' | 'Feminino' | 'Outro' | 'NaoInformado';

export type Paciente = {
  id: string;
  codigo: string;
  nome: string;
  dataNascimento: string | null;
  sexo: Sexo;
  email: string | null;
  telefone: string | null;
  ativo: boolean;
  criadoEm: string;
};

export type CreatePacientePayload = {
  codigo: string;
  nome: string;
  cpf?: string;
  dataNascimento?: string;
  sexo?: Sexo;
  email?: string;
  telefone?: string;
  observacoes?: string;
};

export const listPacientes = (q?: string) =>
  apiFetch<Paciente[]>(`/pacientes${q ? `?q=${encodeURIComponent(q)}` : ''}`);

export const getPaciente = (id: string) => apiFetch<Paciente>(`/pacientes/${id}`);

export const createPaciente = (data: CreatePacientePayload) =>
  apiFetch<Paciente>('/pacientes', { method: 'POST', body: JSON.stringify(data) });

export const updatePaciente = (id: string, data: Partial<CreatePacientePayload> & { ativo?: boolean }) =>
  apiFetch<void>(`/pacientes/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
